import * as React from "react";
import { HeadingName } from "../../HeadingName";
import { renderMarketsColumnsFilter } from "../../../../../helpers";
import { MarketTemplate } from "../../../../../data";

export class RenderMarketNames extends React.PureComponent<{
    marketNames: Array<Array<string>>
    marketTemplates: MarketTemplate[]
    queryParams?: any
}, {}> {

    render() {
        let trimmed = this.props.queryParams
            ? renderMarketsColumnsFilter(this.props.marketNames, this.props.queryParams)
            : this.props.marketNames;

        return (
            <div className="rj-ev-list__heading__names-wrapper" data-uat="div-ev-list-heading-names-wrapper">
                {trimmed.map(
                    (namesArray: string[], index: number) => {
                        let classNames = this.props.marketTemplates[index] ? `rj-ev-list__heading__names--${this.props.marketTemplates[index]}` : "";

                        return <div key={`heading-group-${index}`} className={`rj-ev-list__heading__names ${classNames}`} data-uat="div-ev-list-heading-names">
                            {namesArray.map((name: string, index: number) =>
                                <HeadingName key={`heading-name-${index}`} name={name} />
                            )}
                        </div>
                    }
                )}
            </div>
        )
    }
}